<div class="set-pincode-wp">

    <div class="set-pin-header">
        <h4>{{
                firstPin
                ? 'Re-enter your PIN code'
                : 'Set a PIN code' }}
            </h4>
        <p class="primary-text">
            {{
            firstPin
            ? 'For security purposes, please re-enter your PIN code.'
            : 'For quick sign in, set a 4-digit PIN code for your user account.'}}
        </p>
    </div>

    <div class="control-wp">
        <code-input
            #codeInput
            pnlCiFocusFirstEmpty
            [isCodeHidden]='true'
            [disabled]='isLoading'
            [codeLength]='4'
            [initialFocusField]="0"
            [isFocusingOnLastByClickIfFilled]="true"
            (codeCompleted)='onCodeCompleted($event)'
            (codeChanged)='onCodeChanged($event)'>
        </code-input>
    </div>

    <pnl-error-message *ngIf="activeError" [error]="activeError" [showIcon]="false" ></pnl-error-message>

    <div *ngIf="firstPin" (click)="onGoBack()" class="go-back-btn">
        <span class="go-back-btn-text">Go back</span>
    </div>

</div>

<pn-spinner [color]="'#FFFFFF;'" [visible]="isLoading"></pn-spinner>
